import { ChangeEvent, type ComponentProps } from 'react'

import { FormControl } from './form'
import { TextField, PasswordField } from '../input'

type Props = ComponentProps<typeof TextField> & {
  resetErrorOnBlur?: boolean
}

export const FormTextField = ({ resetErrorOnBlur = true, ...props }: Props) => {
  return (
    <FormControl
      resetErrorOnBlur={resetErrorOnBlur}
      render={renderProps => {
        const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
          renderProps.onChange(event)
          props.onChange?.(event)
        }

        const handleReset = () => {
          renderProps.onChange('')
          props.onChange?.({
            target: {
              value: '',
            },
          } as ChangeEvent<HTMLInputElement>)
        }

        return (
          <TextField
            {...props}
            {...renderProps}
            onReset={handleReset}
            onChange={handleChange}
          />
        )
      }}
    />
  )
}

export const FormPasswordField = (
  props: ComponentProps<typeof PasswordField>,
) => {
  return (
    <FormControl
      render={renderProps => {
        const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
          renderProps.onChange(event)
          props.onChange?.(event)
        }

        const handleReset = () => {
          renderProps.onChange('')
          props.onChange?.({
            target: {
              value: '',
            },
          } as ChangeEvent<HTMLInputElement>)
        }

        return (
          <PasswordField
            {...props}
            {...renderProps}
            onReset={handleReset}
            onChange={handleChange}
          />
        )
      }}
    />
  )
}
